import ChevronRight from '@ixigo/icons/ChevronRight';
import Button from '@ixigo/iui/ButtonBase';
import Typography from '@ixigo/iui/Typography';
import { BottomsheetExtended } from '@repo/shared/components';
import { useEffect, useRef, useState } from 'react';
import { type CabUpdateResponse, getBookingDetail } from '@/api';
import { LineItem } from '@/components/fare-summary';
import { useTripBookingActions } from '../../../-store';

const EXTRA_PAY_ICON_URL =
	'https://images.ixigo.com/image/upload/cabAssets/870f883e72dd910aad709c089d161a0e-abcyl.png';

interface PricingUpdateProps {
	pricingInfo: CabUpdateResponse['pricingInfo'];
	bookingId: string;
}

export const PricingUpdate = ({
	pricingInfo,
	bookingId,
}: PricingUpdateProps) => {
	const [open, setOpen] = useState(false);
	const { setBookingData } = useTripBookingActions();
	const hasShownPricingUpdate = useRef(false);

	useEffect(() => {
		if (pricingInfo && !hasShownPricingUpdate.current) {
			setOpen(true);
			hasShownPricingUpdate.current = true;
		}
	}, [pricingInfo]);

	if (!bookingId || !pricingInfo) {
		return null;
	}

	const handleClose = (scrollToFareSummary: boolean = false) => {
		setOpen(false);
		getBookingDetail(bookingId).then((res) => {
			const hasError = 'errors' in res;
			if (!hasError) {
				setBookingData(res.data);
			}
		});
		if (scrollToFareSummary) {
			document.getElementById('fare-summary')?.scrollIntoView({
				behavior: 'smooth',
				block: 'center',
			});
		}
	};

	const { amountToBePaid, displayFares } = pricingInfo;

	return (
		<BottomsheetExtended
			open={open}
			onClose={() => handleClose()}
			showCloseButton
		>
			<div className="overflow-hidden rounded-t-30 flex flex-col gap-y-5 p-20 pt-30 bg-gradient-to-b from-warning-moderate to-primary">
				<div className="flex flex-col gap-y-20">
					<div className="flex flex-col items-center justify-center gap-y-15">
						<div className="flex-shrink-0 size-[70px] bg-[#FADFB4] flex items-center justify-center rounded-full">
							<img
								src={EXTRA_PAY_ICON_URL}
								alt="extra pay"
								className="size-[42px]"
							/>
						</div>
						<div className="text-center">
							<Typography variant="h4" fontWeight="bold">
								{amountToBePaid.value}
							</Typography>
							<Typography variant="body-md">{amountToBePaid.label}</Typography>
						</div>
					</div>
					<div className="p-15 rounded-20 border border-tertiary bg-primary">
						{displayFares.map((item) => (
							<LineItem key={item.label} {...item} />
						))}
					</div>
				</div>
				<Button className="w-full text-link" onClick={() => handleClose(true)}>
					<span>View Fare Summary</span>
					<ChevronRight />
				</Button>
			</div>
		</BottomsheetExtended>
	);
};
